import React, { memo } from 'react';
import ReactModal from 'react-modal';
import moment from 'moment';

import { ActionButton } from '../../../common';
import { HookForm, HInput, HDatePicker } from '../../../../validation/HForm';
import { transferSaledGoHranModalSheme } from './transferSaledGoHranModalSheme';
import { viewDocument } from '../../../../helpers/data-constants';

import './transferSaledGoHranModal.scss';

const defaultFormState = {
  documentNumber: '',
  transferDate: moment().format('YYYY-MM-DD'),
};

const TransferSaledGoHranModal = memo(({ isOpen, submitTransferSaledStore, handleCloseModal }) => {
  let form = {};
  const handleSubmit = (data) => {
    submitTransferSaledStore({
      ...data,
      transferDate: moment(data.transferDate).format('YYYY-MM-DD'),
    });
  };

  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container"
      overlayClassName="modal-overlay">
      <HookForm
        onSubmit={handleSubmit}
        validationSchema={transferSaledGoHranModalSheme}
        defaultValues={defaultFormState}
        predef={(methods) => (form = methods)}>
        <div className="modal-header transferSaledGoHranModal-modal-header">
          <h2>Реализация товара</h2>
        </div>
        <div className="modal-body">
          <div className="transferSaledGoHranModal-container">
            <div className="form-element">
              <label className="form-element-label" htmlFor="documentNumber">
                Сформировать опись
              </label>
              <div className="form-element-data combobox-lg">
                <HInput h="true" name="documentNumber" className="input" type="text" decimals={0} />
              </div>
            </div>
            <div className="form-element">
              <label className="form-element-label" htmlFor="transferDate">
                Дата передачи
              </label>
              <div className="form-element-data date">
                <HDatePicker h="true" className="input" name="transferDate" id="transferDate" />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer transferSaledGoHranModal-modal-footer">
          <ActionButton text="Сохранить" styleName="button" submit />
          <ActionButton
            text="Отменить"
            func={handleCloseModal}
            param={viewDocument.isTransferdSaledGoHran}
            styleName="button-light"
          />
        </div>
      </HookForm>
    </ReactModal>
  );
});

export default TransferSaledGoHranModal;
